import { useState } from 'react';
import PageContainer from '@/components/Container/PageContainer';
import { useTranslation } from 'react-i18next';
import CreditReport from '@/components/Account/CreditReport';
import { Box, Button as DefaultBtn } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Button } from '../style';
import useUserDetail from '@/hooks/useUserDetail';


const CreditReportEdit = () => {
    // @ts-ignore
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeStep] = useState(6)
  const userDetail = useUserDetail({ activeStep: activeStep });

  const ButtonGroup = (watch: Object) => (
    <Box style={{ marginTop: 30 }}>
      <Button>
        {t('buttons.submit')}
      </Button>
      <DefaultBtn type='button' color="primary" onClick={() => navigate('/profile/edit')} style={{ fontSize: 20, color: '#0B319D', padding: '1px 40px', border: '1px solid #0B319D', marginLeft: 15 }}>
        {t('buttons.back')}
      </DefaultBtn>
    </Box>
  )

  return (
    <PageContainer title={t('creditReport')}>
      <div style={{ display: 'flex' }}>
        <CreditReport ButtonGroup={ButtonGroup} userDetail={userDetail} />
      </div>
    </PageContainer>
  );
};

export default CreditReportEdit;
